import { Info } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

interface NonRenewingTagProps {
  type: "avatar" | "agency";
}

export default function NonRenewingTag({ type }: NonRenewingTagProps) {
  const tooltipLabel = type === "avatar" ? "order" : "subscription";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Tag variant="danger" rightIcon={<Info weight="fill" />}>
          Scheduled cancellation
        </Tag>
      </TooltipTrigger>

      <TooltipContent>
        This {tooltipLabel} is scheduled for cancellation
      </TooltipContent>
    </Tooltip>
  );
}
